module.exports = __webpack_public_path__ + "static/media/photo_001.523949bb.JPG";